import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/api/queryKeys';
import { svgTemplatesApi } from '@/features/deploymentSettings/api/deploymentSettings.api';
import { FALLBACK_TEMPLATES } from '../fallback/blastfurnaceTemplate';

/**
 * Global SVG/HMI template catalog. Returns the BE list when present, otherwise
 * the bundled fallback (blast furnace) so the flow works end-to-end offline or
 * before the BE ships any templates.
 */
export function useSvgTemplates() {
  const query = useQuery({
    queryKey: queryKeys.svgTemplates.all(),
    queryFn: () => svgTemplatesApi.list(),
    staleTime: 5 * 60_000,
  });

  const templates = query.data && query.data.length > 0 ? query.data : FALLBACK_TEMPLATES;
  const usingFallback = !query.isLoading && !(query.data && query.data.length > 0);

  return { ...query, templates, usingFallback };
}
